"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var pop_1 = require("@immutable-array/pop");
exports.pop = pop_1.pop;
var push_1 = require("@immutable-array/push");
exports.push = push_1.push;
var shift_1 = require("@immutable-array/shift");
exports.shift = shift_1.shift;
var unshift_1 = require("@immutable-array/unshift");
exports.unshift = unshift_1.unshift;
var sort_1 = require("@immutable-array/sort");
exports.sort = sort_1.sort;
var reverse_1 = require("@immutable-array/reverse");
exports.reverse = reverse_1.reverse;
var fill_1 = require("@immutable-array/fill");
exports.fill = fill_1.fill;
var splice_1 = require("@immutable-array/splice");
exports.splice = splice_1.splice;
var copy_within_1 = require("@immutable-array/copy-within");
exports.copyWithin = copy_within_1.copyWithin;
//# sourceMappingURL=prototype.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@immutable-array/prototype/lib/prototype.js
// module id = 168
// module chunks = 0